import {getDeviceStatistics} from '../actions/views/NewAlternateView/solutrakApiService';
import NetworkUtils from '../utils/NetworkUtils';
import API from "../services/http";


export const DevicesRepository = {

    async getDeviceStatisticsData(deviceId, date) {
        try {
            const response = await getDeviceStatistics(Number.parseInt(deviceId), date);
            return {success: true, data: response};
        } catch (error) {
            return {success: false, message: NetworkUtils.handleAxiosError(error)};
        }
    },

    async getDeviceEvents(deviceId) {
        try {
            const response = await this.getDeviceDetails(deviceId);
            if (!response.success) {
                return response;
            }

            const events = response.data.deviceEvents;

            return {success: true, data: events};

            // const response = await API.get(`/devices/${deviceId}/events`);
            // if (!response.data?.IsSuccess) {
            //     return { success: false, error: response.data.Message }
            // }
            // return { success: true, data: response.data.Data };
        } catch (error) {
            return {success: false, message: NetworkUtils.handleAxiosError(error)};
        }
    },

    async getDeviceDetails(deviceId) {
        try {
            const response = await API.get('/buildings/getDeviceInfos');
            if (!response.data?.IsSuccess) {
                return {success: false, error: response.data.Message}
            }
            const device = response.data.Data.find((device) => Number.parseInt(device.deviceId) === Number.parseInt(deviceId));
            return {success: true, data: device};
        } catch (error) {
            return {success: false, message: NetworkUtils.handleAxiosError(error)};
        }
    }
}; 
